import React, { useEffect, useState } from "react";
import _ from "lodash";



export default function CommonModalMobile({ renderForm, onSubmit, handleClose, title }: any) {

    return (
        <div className="fixed inset-0 z-50 flex justify-center items-center bg-gray-900 bg-opacity-50 px-4">
            <div className="my-2 mx-auto w-full max-w-[90vw] sm:max-w-[600px] md:max-w-[800px] lg:max-w-[900px] bg-white rounded-lg shadow-lg overflow-auto p-4">
                <div className="flex items-center justify-between border-b p-3">
                    <h2 className="text-lg font-semibold text-gray-700">{title}</h2>
                    <button onClick={handleClose} className="text-gray-500 hover:text-gray-700">
                        <svg
                            xmlns="http://www.w3.org/2000/svg"
                            width="24"
                            height="24"
                            viewBox="0 0 24 24"
                            fill="none"
                            stroke="currentColor"
                            strokeWidth="2"
                            strokeLinecap="round"
                            strokeLinejoin="round"
                            className="lucide lucide-x-circle"
                        >
                            <circle cx="12" cy="12" r="10" />
                            <path d="m15 9-6 6" />
                            <path d="m9 9 6 6" />
                        </svg>
                    </button>
                </div>
                <div className="w-full flex flex-col p-2">{renderForm()}</div>
                <div className="w-full flex justify-end p-2">
                    <button
                        onClick={onSubmit}
                        type="submit"
                        className="border border-[#2A4574] text-[#2A4574] px-4 py-2 text-sm font-medium rounded-md hover:bg-[#2A4574] hover:text-white transition"
                    >
                        Save
                    </button>
                </div>
            </div>
        </div>
    );
}